















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PerformoSettings, Property, PropertiesApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings',
    currentPropertyId: 'currentPropertyId',
    currentProperty: 'currentProperty',
    propertyApi: 'propertiesApi'
  })
})
export default class PropertyPicker extends Vue {
  @Prop({ required: true })
  private value!: string;

  @Prop({ default: false, type: Boolean })
  private inline!: boolean;

  @Prop({ default: false, type: Boolean })
  private hideLabel!: boolean;

  private settings!: PerformoSettings;
  private currentPropertyId!: string;
  private currentProperty!: Property;

  @Prop({ required: false, default: true })
  private setGlobalCurrentProperty?: boolean;

  get getValue() {
    if (this.value) {
      return this.value.toUpperCase();
    }
    return '';
  }

  private propertyApi!: PropertiesApi;
  private properties: Property[] = [];

  get propertiesSorted() {
    if (!this.properties) {
      return null;
    }
    return this.properties.sort((a, b) => {
      if (a.propertyName && b.propertyName) {
        return a.propertyName.localeCompare(b.propertyName);
      }
      return 0;
    });
  }

  private changeHandler() {
    const pickedValue: string = (this.$refs.selectedValue as HTMLSelectElement)
      .value;

    // always emit the input event, so this control works like a regular <select> element.
    this.$emit('input', pickedValue);

    // if the user wants the global store updated, commit the change to vuex
    if (this.setGlobalCurrentProperty) {
      this.$store.commit('setCurrentPropertyId', pickedValue);
      window.localStorage.setItem('currentPropertyId', pickedValue);

      const pickedProperty = this.properties.find(
        (i) => i.propertyId === pickedValue
      );
      if (pickedProperty) {
        this.$store.commit('setCurrentProperty', pickedProperty);
      }
    }
  }

  private async mounted() {
    this.properties = await this.propertyApi.getMyProperties();
    if (this.properties.length === 0) {
      alert(
        'There are no viewable properties for this account. Please contact support.'
      );
      return;
    }

    let currentPropertyUpdate = this.properties.find(
      (i) => i.propertyId === window.localStorage.getItem('currentPropertyId')
    );

    // if valid currentPropertyId local storage value, update vuex
    if (currentPropertyUpdate) {
      this.$store.commit(
        'setCurrentPropertyId',
        currentPropertyUpdate.propertyId
      );
      this.$store.commit('setCurrentProperty', currentPropertyUpdate);
    } else {
      // default currentPropertyId to first element in properties array and commit to vuex
      this.$store.commit('setCurrentPropertyId', this.properties[0].propertyId);

      currentPropertyUpdate = this.properties.find(
        (i) => i.propertyId === this.currentPropertyId
      );
      this.$store.commit('setCurrentProperty', currentPropertyUpdate);
    }
  }
}
